import { createAction } from 'redux-actions';

export const getCategoryGroupListsAction = createAction('GET_CATEGORY_GROUP_LISTS');
export const getCategoryGroupListsSuccessAction = createAction('GET_CATEGORY_GROUP_LISTS_SUCCESS');
export const getCategoryGroupListsFailureAction = createAction('GET_CATEGORY_GROUP_LISTS_FAILURE');
